import { createSlice } from "@reduxjs/toolkit";

import {
  setSelectedStrategyReducer,
  setSelectedPortfolioReducer,
  setPortfolioSearchValueReducer,
  setActiveStrategiesReducer,
  setShowAddFundsModalReducer,
  setShowStatusModalReducer,
  setPortfolioViewModeReducer,
  setSelectedPortfolioIdsReducer,
} from "./reducer";

const initialState = {
  tradingDetail: {},
  selectedStrategy: {},
  selectedPortfolio: {},
  activeStrategies: {
    data: [],
    isLoading: false,
    isSubLoading: false,
    totalPages: 0,
    totalCount: 0,
  },
  portfolioSearchValue: "",
  showAddFundsModal: false,
  showStatusModal: "",
  portfolioViewMode: "combined", // "combined" or "individual"
  selectedPortfolioIds: [], // array of portfolio IDs
};

export const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {
    setSelectedStrategy: setSelectedStrategyReducer,
    setSelectedPortfolio: setSelectedPortfolioReducer,
    setPortfolioSearchValue: setPortfolioSearchValueReducer,
    setActiveStrategies: setActiveStrategiesReducer,
    setShowAddFundsModal: setShowAddFundsModalReducer,
    setShowStatusModal: setShowStatusModalReducer,
    setPortfolioViewMode: setPortfolioViewModeReducer,
    setSelectedPortfolioIds: setSelectedPortfolioIdsReducer,
  },
});

export const {
  setSelectedStrategy,
  setSelectedPortfolio,
  setPortfolioSearchValue,
  setActiveStrategies,
  setShowAddFundsModal,
  setShowStatusModal,
  setPortfolioViewMode,
  setSelectedPortfolioIds,
} = portfolioSlice.actions;

export default portfolioSlice.reducer;
